import { render, staticRenderFns } from "./algorithm.vue?vue&type=template&id=94625c98&scoped=true&"
import script from "./algorithm.vue?vue&type=script&lang=js&"
export * from "./algorithm.vue?vue&type=script&lang=js&"
import style0 from "./algorithm.vue?vue&type=style&index=0&id=94625c98&scoped=true&lang=scss&"
import style1 from "./algorithm.vue?vue&type=style&index=1&id=94625c98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94625c98",
  null
  
)

export default component.exports